import sliderSVG from '@plone/volto/icons/slider.svg';
import { Edit as EmblaCarouselEdit, View as EmblaCarouselView} from './components/Blocks/EmblaCarousel';

const applyConfig = (config) => {
  config.settings.isMultilingual = false;
  config.settings.supportedLanguages = ['en'];
  config.settings.defaultLanguage = 'en';
  config.blocks.themes = [
    {
      style: {
        '--theme-color': 'white',
        '--theme-high-contrast-color': 'var(--lightgrey)',
        '--theme-foreground-color': 'black',
        '--theme-low-contrast-foreground-color': 'var(--grey)',
      },
      name: 'default',
      label: 'Default',
    },
    {
      style: {
        '--theme-color': 'var(--lightgrey)',
        '--theme-high-contrast-color': 'black',
        '--theme-foreground-color': 'black',
        '--theme-low-contrast-foreground-color': 'var(--lightgrey)',
      },
      name: 'lightgrey',
      label: 'Light Grey',
    },
    {
      style: {
        '--theme-color': 'var(--priceless-dark-blue)',
        '--theme-high-contrast-color': 'white',
        '--theme-foreground-color': 'white',
        '--theme-low-contrast-foreground-color': 'var(--lightgrey)',
      },
      name: 'darkblue',
      label: 'Dark Blue',
    },
    {
      style: {
        '--theme-color': 'var(--priceless-blue)',
        '--theme-high-contrast-color': 'white',
        '--theme-foreground-color': 'white',
        '--theme-low-contrast-foreground-color': 'var(--lightgrey)',
      },
      name: 'blue',
      label: 'Blue',
    },
    {
      style: {
        '--theme-color': 'var(--priceless-pale-blue)',
        '--theme-high-contrast-color': 'white',
        '--theme-foreground-color': 'white',
        '--theme-low-contrast-foreground-color': 'var(--lightgrey)',
      },
      name: 'paleblue',
      label: 'Pale Blue',
    },
  ];

  //Add additional volto-columns-block colours here

  config.blocks.blocksConfig.columnsBlock.available_colors = [
    // '#B80000',
    // '#DB3E00',
    // '#FCCB00',
    // '#008B02',
    // '#006B76',
    // '#1273DE',
    // '#004DCF',
    // '#5300EB',
    '#EFEFEF',
    '#EB9694',
    '#FAD0C3',
    '#FEF3BD',
    '#C1E1C5',
    '#BEDADC',
    '#C4DEF6',
    '#BED3F3',
    '#D4C4FB',
  ];

  //enable autoplay
  config.blocks.blocksConfig.slider.enableAutoPlay = true;

  config.blocks.blocksConfig.EmblaCarousel = {
    id: 'EmblaCarousel',
    title: 'Embla Carousel',
    icon: sliderSVG,
    group: 'common',
    view: EmblaCarouselView,
    edit: EmblaCarouselEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  return config;
};

export default applyConfig;
